export const PROGRESS_MESSAGES = {
  AUTHENTICATING: 'Authenticating',
  LOADING: 'Loading',
  LOADING_DATA: 'Loading Data',
  SAVING_DATA: 'Saving Data',
};

export default PROGRESS_MESSAGES;